module.exports = __webpack_public_path__ + "static/media/shdocvw_272.f192d45e.ico";